import React, { useEffect, useState } from "react";
import { Button, Empty, Spin, Typography } from "antd";
import ProfileHeader from "../../Proflie/ProfileHeader";
import ExploreAgentCard from "../../Card/ExploreAgentCard";
import { TiArrowSortedDown } from "react-icons/ti";
import { fetchAssistantsCreatedBySuperAdmin } from "../../../api/assistant";
import { getUserID } from "../../../Utility/service";
import { axiosOpen } from "../../../api/axios";
import { USER_COMPANY_DATA_API_SLUG } from "../../../constants/Api_constants";

const { Title } = Typography;

const IndustryAgents = ({
  chatWithAssistant,
  addFavoriteAssistant,
  userId,
  handleCardClick,
  favoriteAssistant,
  setRefresh,
  setFavoriteAssistant,
  HeaderContentChildren,
  enablePersonalize = false,
}) => {
  const [myAgents, setMyAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [userIndustry, setUserIndustry] = useState("");

  useEffect(() => {
    const fetchUserIndustry = async () => {
      console.log("🔄 Fetching user industry for userId:", userId);
      try {
        const userResponse = await axiosOpen.get(USER_COMPANY_DATA_API_SLUG(userId));
        console.log("📦 User response:", userResponse);
        const industry = userResponse?.data?.industry || "";
        console.log("📡 User Industry:", industry);
        setUserIndustry(industry);
      } catch (error) {
        console.error("❌ Failed to fetch user industry:", error);
        setUserIndustry(""); // Fallback to empty string
      }
    };

    if (userId) {
      console.log("🧠 Fetching industry for userId:", userId);
      fetchUserIndustry();
    } else {
      console.warn("❗ No userId provided, skipping industry fetch.");
    }
  }, [userId]);

  useEffect(() => {
    console.log("Fetching assistants for userId:", userId, "with industry:", userIndustry);

    if (!userId || !userIndustry) {
      console.warn("No userId or userIndustry, skipping API call.");
      return;
    }

    const fetchAssistants = async () => {
      setLoading(true);
      try {
        const response = await fetchAssistantsCreatedBySuperAdmin(page, 10, userIndustry);
        console.log("Full API Response:", response);

        if (response?.data) {
          setMyAgents(prev => (page === 1 ? response.data : [...prev, ...response.data]));
          setTotal(response.meta.total);
          console.log("Updated My Agents State:", response.data);
          console.log("Total Assistants:", response.meta.total);
        } else {
          console.warn("No assistants found in API response.");
        }
      } catch (error) {
        console.error("Error fetching assistants:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAssistants();
  }, [userId, userIndustry, page]);

  const handleLoadMore = () => {
    if (myAgents.length < total) {
      setPage(prev => prev + 1);
      console.log("Load More clicked, new page:", page + 1);
    }
  };

  return (
    <Spin spinning={loading}>
      <ProfileHeader
        title={`${userIndustry ? `${userIndustry} ` : ""}Agents`}
        subHeading={`Explore agents tailored for ${userIndustry || "your industry"}.`}
      />
      {HeaderContentChildren}

      <div>
        {myAgents.length === 0 && !loading ? (
          <>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            <p className="text-center">No assistants found for your industry.</p>
            {console.log("Rendering Empty State: No assistants in myAgents")}
          </>
        ) : (
          <div className="assistant-container">
            {myAgents.map((assistant) => (
              <ExploreAgentCard
                key={assistant._id}
                agent={assistant}
                chatWithAssistant={chatWithAssistant}
                addFavoriteAssistant={addFavoriteAssistant}
                userId={userId}
                handleCardClick={handleCardClick}
                favoriteAssistantData={favoriteAssistant}
                setRefresh={setRefresh}
                setFavoriteAssistant={setFavoriteAssistant}
                enablePersonalize={enablePersonalize}
              />
            ))}
          </div>
        )}
      </div>

      {myAgents.length > 0 && myAgents.length < total && (
        <div className="load-more-container mt-1">
          <div className="load-more-button">
            <Button
              size="small"
              icon={<TiArrowSortedDown />}
              onClick={handleLoadMore}
            >
              Load More
            </Button>
          </div>
          <hr
            style={{
              borderColor: "hsl(0, 0%, 80%)",
              marginTop: "24px",
            }}
          />
        </div>
      )}

      {myAgents.length >= total && myAgents.length > 0 && (
        <span className="text-center w-100 d-block">There is no more data</span>
      )}
    </Spin>
  );
};

export default IndustryAgents;